import { Button, Grid, makeStyles, Typography } from '@material-ui/core'
import { FC, useRef } from 'react'
import { Form as FinalForm } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import MyTextfield from '../../../control/textfield/textfield'
import useTranslate from '../../../i18n/useTranslate'
import useProjectStatus from '../../../services/um/lookups/useProjectStatus'
import { GetDocumentResponse, UplodeFileDocType } from '../../../services/um/useSettingDocument'
import MultiSelect from '../../../control/multiSelect/multiSelect'
import { ValidationErrors } from 'final-form'
import Checkbox from '../../../control/checkbox/checkbox'
import UploadDocFile from '../../web/shareUI/uploadDoc/UploadDocFile'

type FormProps = {
    initialValues: GetDocumentResponse
    onSubmit: (values: any) => void
    onClickBack: () => void
    initialUploadFile?: UplodeFileDocType[]
    topicInitial: { id: number | string; name_th: string; name_en: string }[]
}

const Form: FC<FormProps> = ({ onSubmit, initialValues, onClickBack, initialUploadFile, topicInitial }) => {
    const classes = useStyle()
    const translate = useTranslate()
    const { projectStatus } = useProjectStatus()
    let defaultSubmittedType = initialValues.submittedTypeID?.map((item) => item.toString()) ?? undefined
    const formValuesRef = useRef<GetDocumentResponse>()

    const validation = (values: GetDocumentResponse) => {
        const errors: ValidationErrors = {}

        if (!values.submittedTypeID) {
            errors.submittedTypeID = translate.get('MESSAGE.M016')
        }
        if (values.submittedTypeID && values.submittedTypeID.length < 1) {
            errors.submittedTypeID = translate.get('MESSAGE.M016')
        }

        return errors
    }
    return (
        <FinalForm
            onSubmit={onSubmit}
            initialValues={initialValues}
            validate={validation}
            mutators={{
                ...arrayMutators,
            }}
        >
            {({ handleSubmit, values }) => {
                formValuesRef.current = values

                /*const isHasValue = () => {
                    let isUploadValueTH: boolean = false
                    let isUploadValueEN: boolean = false
                    formValuesRef.current?.documentInfo?.forEach((item, index) => {
                        if (!index) {
                            if (item?.uploadFileObj?.fileList[0]?.filename) {
                                isUploadValueTH = true
                            }
                        } else {
                            if (item?.uploadFileObj?.fileList[0]?.filename) {
                                isUploadValueEN = true
                            }
                        }
                    })
                    return isUploadValueTH && isUploadValueEN
                }*/
                return (
                    <Grid container className={classes.container} spacing={2}>
                        <Grid item xs={12} md={6}>
                            <MyTextfield
                                name="code"
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGDOCUMENT.FORM.CODE')}`,
                                    disabled: false,
                                    placeholder: `${translate.get('UM.SETTINGDOCUMENT.FORM.CODE')}`,
                                    size: 'small',
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MultiSelect
                                name="submittedTypeID"
                                option={projectStatus}
                                label={translate.get('UM.SETTINGDOCUMENT.FORM.PROJECT_SUBMIT_TYPE')}
                                placeholder={translate.get('UM.SETTINGDOCUMENT.FORM.PROJECT_SUBMIT_TYPE')}
                                size="small"
                                defaultValue={defaultSubmittedType}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MyTextfield
                                name="nameTH"
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGDOCUMENT.FORM.NAME_TH')}`,
                                    disabled: false,
                                    placeholder: `${translate.get('UM.SETTINGDOCUMENT.FORM.NAME_TH')}`,
                                    size: 'small',
                                }}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MyTextfield
                                name="nameEN"
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGDOCUMENT.FORM.NAME_EN')}`,
                                    disabled: false,
                                    placeholder: `${translate.get('UM.SETTINGDOCUMENT.FORM.NAME_EN')}`,
                                    size: 'small',
                                }}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MyTextfield
                                name="shortNameTH"
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGDOCUMENT.FORM.SHORTNAME_TH')}`,
                                    disabled: false,
                                    placeholder: `${translate.get('UM.SETTINGDOCUMENT.FORM.SHORTNAME_TH')}`,
                                    size: 'small',
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MyTextfield
                                name="shortNameEN"
                                materialInputProps={{
                                    label: `${translate.get('UM.SETTINGDOCUMENT.FORM.SHORTNAME_EN')}`,
                                    disabled: false,
                                    placeholder: `${translate.get('UM.SETTINGDOCUMENT.FORM.SHORTNAME_EN')}`,
                                    size: 'small',
                                }}
                            />
                        </Grid>
                        <Grid container item xs={12}>
                            <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                                {translate.get('LABEL.UPLOAD_FILES')}
                            </Typography>

                            <Typography variant="body1" className={classes.uploadTitle}>
                                ({translate.get('ALERT.CONTENT.UPLOAD_PDF_WORD_AT_1_FILE_TIMES')})
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <UploadDocFile
                                name="documentInfo"
                                documentTitleList={topicInitial}
                                accept={'.pdf,.doc,.docx'}
                                initialData={initialUploadFile as any}
                                multipleFiles={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Checkbox
                                name="isDisplayDocument"
                                label={translate.get('LABEL.SHOW_DOCUMENT_TOPIC')}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justify="flex-end" spacing={2}>
                                <Grid item>
                                    <Button
                                        size={'large'}
                                        variant="contained"
                                        className={classes.cancelButton}
                                        onClick={onClickBack}
                                    >
                                        {translate.get('BUTTON.CANCEL')}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        size={'large'}
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        className={classes.saveButton}
                                        style={{ minWidth: '0px' }}
                                    >
                                        {translate.get('BUTTON.SAVE')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            }}
        </FinalForm>
    )
}

export default Form

const useStyle = makeStyles((theme) => ({
    container: {
        margin: '-8px',
    },
    reset: {
        textDecoration: 'underline',
        cursor: 'pointer',
        padding: '0px 1.5rem',
        alignSelf: 'center',
    },
    root: {
        width: '100%',
        height: '100%',
        padding: '1rem 0px',
    },
    cancelButton: {
        backgroundColor: '#FFFFFF',
        border: 'solid 1px #db5f8e',
    },
    saveButton: {
        border: 'solid 1px #db5f8e',
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
    },
    uploadTitle: {
        color: 'red',
        paddingTop: '5px',
        paddingLeft: '10px',
    },
}))
